import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react';
import { makeStyles, Typography, InputBase } from '@material-ui/core';
import { AutoCompleteInput, Dialog } from '../../../../components';
import { i18n } from '../../../../language';

const useStyles = makeStyles((theme) => ({
  error: {
    color: '#f44336',
    fontFamily: 'NotoSans-Medium',
    fontWeight: '500',
    fontSize: '1rem',
    margin: '1rem 0.825rem 1rem 0.825rem',
  },
  dialog: {
    '& .MuiPaper-root': {
      padding: '0',
      margin: '0',
      boxShadow: 'unset',
    },
  },
  root: {
    display: 'flex',
    flexDirection: 'column',
    width: '43.75rem',
    borderRadius: '0.625rem',
    boxShadow: '0 -2px 21px 0 rgba(30, 56, 140, 0.18)',
    backgroundColor: '#fff',
    overflow: 'auto',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '2.375rem 1.875rem 1.563rem 1.563rem',
  },
  headerTitle: {
    fontFamily: 'NotoSans-Bold',
    fontSize: '1.5rem',
    fontWeight: 'bold',
    color: '#2e4469',
  },
  closeIcon: {
    fontSize: '1.375rem',
    color: '#538fff',
    margin: '-12px -12px 0 0',
  },
  label: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '0.875rem',
    fontWeight: 500,
    color: '#7d86a9',
    marginBottom: '0.625rem',
  },
  main: {
    padding: '0 1.563rem',
    overflow: 'auto',
  },
  InputBase: {
    height: '3.5rem',
    borderRadius: '0.625rem',
    border: 'solid 1px #e4e7eb',
    width: '100%',
    paddingLeft: '1.25rem',
    marginBottom: '1.875rem',
    '& .MuiInputBase-input': {
      fontSize: '1rem',
      color: '#2e4469',
      fontFamily: 'NotoSans-Medium',
    },
    '& .MuiInputBase-input.Mui-disabled': {
      color: '#777',
    },
    '& .MuiInputBase-root.Mui-disabled': {
      background: '#fafafa !importent',
    },
  },
  autoCompleteInput: {
    '& .MuiInputBase-input.Mui-disabled': {
      color: '#777',
    },
    '& .MuiInputBase-root.Mui-disabled': {
      borderRadius: '0.625rem',
      backgroundColor: '#fafafa',
    },
  },
  cancelBtn: {
    width: '12.5rem',
    height: '3rem',
    borderRadius: '0.625rem',
    border: 'solid 1.5px #538fff',
    color: '#538fff',
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    fontWeight: '500',
    background: '#f5faff',
  },
  configBtn: {
    width: '12.5rem',
    height: '3rem',
    borderRadius: '0.625rem',
    background: '#538fff',
    color: '#fff',
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    fontWeight: '500',
  },
}));

const PopEdit = (props, ref) => {
  const classes = useStyles();
  // input

  const [dialogTitle, dialogTitleSet] = useState('');
  const [open, openSet] = useState(false);
  const [rowValue, rowValueSet] = useState({});
  const [categoryOptions, categoryOptionsSet] = useState([]);
  const [errorMessage, setErrorMessage] = useState({});
  const [confirmDisabled, setConfirmDisabled] = useState(false);

  const onConfirm = useRef();

  useImperativeHandle(ref, () => ({
    init: () => {
      rowValueSet({});
    },

    setOnConfirm: (fn) => {
      onConfirm.current = fn;
    },
    setRowValue: (rowValue) => {
      rowValueSet(rowValue);
    },
    setCategoryOptions: (categorys) => {
      categoryOptionsSet(categorys.map((el) => ({ text: el, value: el })));
    },
    open: () => {
      openSet(true);
    },
    close: () => {
      openSet(false);
    },
    setDialogTitle: (title) => {
      dialogTitleSet(title);
    },
  }));

  useEffect(() => {
    checkError();
  }, [rowValue]);

  const isEmpty = (data) => {
    return data === undefined || data === null || data?.trim() === '';
  };

  const checkError = () => {
    let err = { category: null, subCategory: null };
    if (isEmpty(rowValue?.category)) {
      err = {
        ...err,
        category: i18n.t('DUTYASSIGN_ROSTER_SETTING_ERROR_CATEGORY_REQUIRED'),
      };
    }
    if (isEmpty(rowValue?.subCategory)) {
      err = {
        ...err,
        subCategory: i18n.t('DUTYASSIGN_ROSTER_SETTING_ERROR_SUBCATEGORY_REQUIRED'),
      };
    }
    setErrorMessage({ ...err });
    setConfirmDisabled(err.category || err.subCategory);
  };

  return (
    <Dialog
      title={dialogTitle}
      cancel={i18n.t('DUTYASSIGN_CANCEL')}
      confirm={i18n.t('DUTYASSIGN_CONFIRM')}
      open={open}
      id="DutyAssign-Dialog-agx"
      handleOnClose={() => {
        return;
      }}
      handleClose={() => {
        openSet(false);
      }}
      handleCancel={() => {
        openSet(false);
      }}
      handleConfirm={() => {
        onConfirm.current(rowValue);
      }}
      disabled={confirmDisabled}
    >
      <Typography className={classes.label}>
        {i18n.t('DUTYASSIGN_CREATE_CHATROOM_CATEGORY_TITLE')}
        {(rowValue.category || '').trim().length > 0 &&
          categoryOptions.filter((el) => el.value === rowValue.category).length <= 0 && (
            <span style={{ color: 'red' }}>{i18n.t('DUTYASSIGN_ROSTER_SETTING_NEW_CATEGORY_MSG')}</span>
          )}
      </Typography>

      <AutoCompleteInput
        id="setting_role_pop_rolename"
        className={classes.autoCompleteInput}
        placeholder={i18n.t('DUTYASSIGN_CREATE_CHATROOM_CATEGORY_TITLE')}
        style={{ marginBottom: '.8rem' }}
        value={rowValue.category}
        itemList={categoryOptions}
        freeSolo
        onChange={(val) => {
          const rv = { ...rowValue };
          rv.category = val;
          rowValueSet({ ...rv });
        }}
        errorMsg={errorMessage?.category}
        disabled={rowValue?.deleteDisabled === 1}
      />
      <Typography className={classes.label}>{i18n.t('DUTYASSIGN_ROSTER_SETTING_SUBCATEGORY_TITLE')}</Typography>
      <div>
        <InputBase
          id="setting_role_pop_roletypeid"
          className={classes.InputBase}
          style={{
            borderColor: errorMessage.subCategory ? '#f44336' : '#e4e7eb',
            marginBottom: errorMessage.subCategory ? 0 : '1.875rem',
          }}
          placeholder={i18n.t('DUTYASSIGN_ROSTER_SETTING_SUBCATEGORY_TITLE')}
          value={rowValue.subCategory}
          onChange={(e) => {
            const rv = { ...rowValue };
            rv.subCategory = e.target.value;
            rowValueSet({ ...rv });
          }}
          errorMsg={errorMessage?.subCategory}
          disabled={rowValue?.deleteDisabled === 1}
        />
        {errorMessage.subCategory && <p className={classes.error}>{errorMessage.subCategory}</p>}
      </div>

      <Typography className={classes.label}>{i18n.t('DUTYASSIGN_ROSTER_SETTING_CORPID_TITLE')}</Typography>
      <InputBase
        id="setting_role_pop_corpid"
        className={classes.InputBase}
        placeholder={i18n.t('DUTYASSIGN_ROSTER_SETTING_CORPID_PLACEHOLDER')}
        value={rowValue.ccCorpId}
        onChange={(e) => {
          const rv = { ...rowValue };
          rv.ccCorpId = e.target.value;
          rowValueSet({ ...rv });
        }}
        errorMsg={errorMessage?.ccCorpId}
      />
    </Dialog>
  );
};

export default forwardRef(PopEdit);
